module.exports = __webpack_public_path__ + "static/media/rm_06-38.a1bbab7a.png";